import { AlertCircle, RefreshCw } from "lucide-react";

export const ErrorState = ({ message, onRetry }) => {
  return (
    <div className="glass-card p-8 text-center" data-testid="error-state">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-ignition-red/20 mb-4">
        <AlertCircle className="w-8 h-8 text-ignition-red" strokeWidth={1.5} />
      </div>
      <h3 className="font-heading font-bold text-white text-lg mb-2">
        Something went wrong
      </h3>
      <p className="text-slate-400 mb-4">{message || "Unable to load data. Please try again."}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn-outline inline-flex items-center gap-2"
          data-testid="retry-btn"
        >
          <RefreshCw className="w-4 h-4" strokeWidth={1.5} />
          Try Again
        </button>
      )}
    </div>
  );
};

export const EmptyState = ({ title, message, icon: Icon }) => {
  return (
    <div className="glass-card p-8 text-center" data-testid="empty-state">
      {Icon && (
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-4">
          <Icon className="w-8 h-8 text-slate-500" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-heading font-bold text-white text-lg mb-2">
        {title || "No data available"}
      </h3>
      <p className="text-slate-400">{message || "Check back later for updates."}</p>
    </div>
  );
};

export const LoadingState = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12" data-testid="loading-state">
      <div className="loading-spinner mb-4" />
      <p className="text-slate-400 font-heading uppercase tracking-wider text-sm">
        {message || "Loading..."}
      </p>
    </div>
  );
};
